import StyledLink from '../StyledLink'
import {
  CONTROLLER,
  IMPORT,
  REQUIREMENTS
} from '../routes'
import type { Props } from '../types'

const LinkToImportRequirements = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + CONTROLLER + '/' + REQUIREMENTS + '/' + IMPORT}
  >
    {children}
  </StyledLink>

export default LinkToImportRequirements
